import React, { useState, useEffect } from "react";
import "./AjeetMiniCard.css";

const AjeetMiniCard = () => {
  const images = [
    "https://res.cloudinary.com/dmv2tjzo7/image/upload/v1738302760/x0gpgusknr2p2lfadmz3.png",
    "https://res.cloudinary.com/dmv2tjzo7/image/upload/v1761896997/Screenshot_2025-10-30_160917_xvmy68-removebg-preview_ltnuwc.png",
    "https://res.cloudinary.com/dmv2tjzo7/image/upload/v1761821013/certificate-removebg-preview_lbydgu.png",
  "https://res.cloudinary.com/dmv2tjzo7/image/upload/v1762147190/Screenshot_2025-11-03_104859-removebg-preview_k55h6x.png"
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000); // change every 3 seconds
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="zuppa_home_ajeetmini_pg_wrapper">

      {/* === First Parallax Section === */}
      <section className="zuppa_home_ajeetmini_pg_parallax zuppa_home_ajeetmini_pg_img1">
        <div className="zuppa_home_ajeetmini_pg_overlay">
          <h1 className="zuppa_home_ajeetmini_pg_title">AJEET MINI</h1>
        </div>
      </section>

      {/* === Content Section with Image Slider === */}
      <section className="zuppa_home_ajeetmini_pg_content">
        <div className="container text-center py-5">
          <div className="row align-items-center">
            
            {/* Left - Image Slider */}
            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
              <div className="zuppa_home_ajeetmini_pg_slider_wrapper">
                {images.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`Slide ${index + 1}`}
                    className={`zuppa_home_ajeetmini_pg_image ${
                      index === currentImage ? "active" : ""
                    }`}
                  />
                ))}
              </div>
            </div>

            {/* Right - Content */}
            <div className="col-lg-6 col-md-12">
              <h2 className="zuppa_home_ajeetmini_pg_heading">
               AJEET Mini TRAINER 
              </h2>
              <p className="zuppa_home_ajeetmini_pg_para">
              This advanced model features dual remote controls (Master and Slave) for 
              collaborative training and superior accuracy. Perfect for training academies, 
              professional UAV pilots, and team-based learning environments. </p>
            </div>

          </div>
        </div>
      </section>

     

    </div>
  );
};

export default AjeetMiniCard;
